import { createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/login/lee-blanco.png'


const _withScopeId = n => (_pushScopeId("data-v-66d0e9ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "CajitaLogin animate__animated animate__slideInDown",
  id: "LHAlogin"
}
const _hoisted_2 = { class: "col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 CajitaData CajitaData1" }
const _hoisted_3 = { class: "CajitadatosInicio" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3 text-center TituloPrin" }, null, -1))
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label usuconLabel" }, "Usuario:", -1))
const _hoisted_7 = { class: "mb-3 DivContra" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label usuconLabel" }, "Contraseña:", -1))
const _hoisted_9 = { class: "mb-3 DivContra text-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 CajitaData CajitaData2" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_11 = {
  key: 1,
  class: "Cargando"
}
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"wrapper\" data-v-66d0e9ae><div class=\"circle circle1\" data-v-66d0e9ae></div><div class=\"circle circle2\" data-v-66d0e9ae></div><div class=\"circle circle3\" data-v-66d0e9ae></div><div class=\"shadow\" data-v-66d0e9ae></div><div class=\"shadow\" data-v-66d0e9ae></div><div class=\"shadow\" data-v-66d0e9ae></div><span data-v-66d0e9ae>Cargando</span></div>", 1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 2,
  class: "CajitaDatosMenu animate__animated animate__slideInDown"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuVue = _resolveComponent("MenuVue")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.LHAlogin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("input", {
                  type: "text",
                  id: "InputUser",
                  class: "form-control rounded-pill",
                  onKeyup: _cache[0] || (_cache[0] = _withKeys(($event: any) => (_ctx.ValidaDatos()), ["enter"])),
                  onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.QuitarStilos('InputUser')))
                }, null, 32)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("input", {
                  type: "password",
                  id: "InputPass",
                  class: "form-control rounded-pill",
                  onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.ValidaDatos()), ["enter"])),
                  onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.QuitarStilos('InputPass')))
                }, null, 32),
                (!_ctx.LHAOjitoV)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: "bi bi-eye-fill ojito",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.VeroNo('InputPass')))
                    }))
                  : _createCommentVNode("", true),
                (_ctx.LHAOjitoV)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 1,
                      class: "bi bi-eye-slash-fill ojito",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.VeroNo('InputPass')))
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.ValidaDatos())),
                  class: "btn btn-primary rounded-pill"
                }, "Acceder")
              ])
            ])
          ]),
          _hoisted_10
        ]))
      : _createCommentVNode("", true),
    (_ctx.Cargando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
      : _createCommentVNode("", true),
    (_ctx.LHAMenu && !_ctx.LHAlogin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createVNode(_component_MenuVue, { message: _ctx.LlegaDelLogin }, null, 8, ["message"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}